import styled, { css } from 'styled-components';
import { Icon, loading, Typography } from '@web-chat-core/ui-kit';
import { ControlButton } from 'ui/components';
import { SizeVariant } from 'ui/components/ControlButton/types';

const smallButtonPadding = (size?: SizeVariant) => css`
    ${() => {
        if (size === 'small') {
            return css`
                padding: 4px;
            `;
        }

        return null;
    }}
`;

export const StartRecordButtonBase = styled(ControlButton)`
    ${({ size }) => smallButtonPadding(size)}
`;

export const LoadingRecordButtonBase = styled(ControlButton)`
    ${({ size }) => smallButtonPadding(size)}
`;

export const RecordInProgressButtonBase = styled(ControlButton)`
    ${({ size }) => smallButtonPadding(size)}
`;

export const StartRecordIcon = styled(Icon)`
    --ic-inner-color: ${(props) => props.theme.root.colors.basicColors['90%']};
`;

export const LoadingRecordIcon = styled(Icon)`
    --ic-inner-color: ${(props) => props.theme.root.colors.basicColors['90%']};
    ${loading}
`;

export const RecordInProgressIcon = styled(Icon)`
    --ic-outer-color: ${(props) => props.theme.root.colors.basicColors['90%']};
    --ic-inner-color: ${(props) => props.theme.root.colors.system.dangerDefault};
`;

export const RecordInProgressText = styled(Typography)`
    margin-left: 4px;
`;
